import React from 'react'
import CheckAttendanceAdminContent from '../../Component/CheckAttendanceAdminContent/CheckAttendanceAdminContent'
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
function CheckAttendanceAdmin() {
  return   <CheckAttendanceAdminContent />
      
}

export default CheckAttendanceAdmin
